import IndicatorButton from 'components/indicator/IndicatorButton';
import CompanyBasicInfoSection from './components/CompanyBasicInfoSection';
import IntegrationSection from './components/IntegrationSection';
import MailDeliverySection from './components/MailDeliverySection';
import PrivacyCopyrightSection from './components/PrivacyCopyrightSection';
import TermsSection from './components/TermsSection';
import { useSettingCompany } from './hooks/useSettingCompany';

import type { JSX } from 'react';

/**
 * カンパニー設定画面
 */
export default function SettingCompany(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const {
    initialized,
    processing,
    processingOnPreview,
    useFormMethods,
    imageCropper,
    isAdmin,
    isTermsInputDivUrl,
    isTermsInputDivText,
    activePlan,
    acctState,
    onImageUpload,
    onImageDelete,
    onPreviewTerms,
    onResetTerms,
    onSave,
  } = useSettingCompany();

  const {
    register,
    control,
    formState: { errors },
  } = useFormMethods;

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  if (!initialized) return <></>;

  return (
    <>
      <section className="section-header">
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">基本設定</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="section-basic-setting">
        <div className="container">
          <div className="box-common">
            <form className="form-profile g-3">
              <div className="d-md-flex d-flex-header">
                <div className="flex-shrink-0 flex-left mb-3">
                  <h3 className="title-section title-md fw-bold">会社情報</h3>
                </div>
                {isAdmin && (
                  <div className="flex-grow-1 flex-right">
                    <ul className="list-inline list-btn mb-0">
                      <li className="list-inline-item">
                        <button
                          onClick={onSave}
                          type="button"
                          className="btn btn-common btn-common-w200 moderate-blue py-2 js-button-change"
                          disabled={processing}
                        >
                          <IndicatorButton visible={processing} />
                          変更する
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <CompanyBasicInfoSection
                register={register}
                errors={errors}
                isAdmin={isAdmin}
                imageCropper={imageCropper}
                activePlan={activePlan}
                acctState={acctState}
                onImageUpload={onImageUpload}
                onImageDelete={onImageDelete}
              />
              <MailDeliverySection
                register={register}
                errors={errors}
                control={control}
                isAdmin={isAdmin}
              />
              <PrivacyCopyrightSection register={register} errors={errors} isAdmin={isAdmin} />
              <TermsSection
                register={register}
                errors={errors}
                control={control}
                isAdmin={isAdmin}
                isTermsInputDivUrl={isTermsInputDivUrl}
                isTermsInputDivText={isTermsInputDivText}
                onPreviewTerms={onPreviewTerms}
                onResetTerms={onResetTerms}
                processingOnPreview={processingOnPreview}
              />
              <IntegrationSection register={register} errors={errors} isAdmin={isAdmin} />
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
